<template>
  <div class="tooltipRoot">
    <slot name="trigger" />
    <span class="content">
      <slot />
    </span>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Tooltip',
});
</script>

<style lang="scss" scoped>
/* Tooltip container */
.tooltipRoot {
  position: relative;
  display: flex;
  justify-content: center;
}

/* Tooltip text */
.tooltipRoot .content {
  visibility: hidden;
  position: absolute;
  background: $gray-900;
  color: white;
  padding: 1rem;
  border-radius: 16px;
  z-index: 9999;
  bottom: 140%;
  width: 450px;
}

.tooltipRoot:hover .content {
  visibility: visible;
}

.tooltipRoot .content::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -1px;
  border-width: 5px;
  border-style: solid;
  border-color: #0a1f44 transparent transparent transparent;
}
</style>
